var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMemo } from 'react';
import { useGetDeveloperPlatformCapabilities } from '#query-hooks';
export const useIsNativeLayoutEnabled = (workspaceId) => {
    _react_refresh_temp_1();
    const { query: { data }, } = useGetDeveloperPlatformCapabilities(workspaceId);
    return useMemo(() => Boolean(data?.capabilities.nativeLayout.enabled), [data]);
};
_react_refresh_temp_1(useIsNativeLayoutEnabled, "x333ohHfAebZl/NzLzlIodjPooo=", false, () => [useGetDeveloperPlatformCapabilities]);
